var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreat1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#636053;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Filler_injection_1596585",
    "data-name": "noun Filler injection 1596585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    className: "cls-1",
    d: "M58,31H55V29a1,1,0,0,0-1-1h-7a24.15,24.15,0,0,0,1-6.6V18a18,18,0,0,0-36,0v3.4A24.07,24.07,0,0,0,22,40.87V50H10A10,10,0,0,0,0,60H2a8,8,0,0,1,8-8H23a1,1,0,0,0,1-1V42.18c.58.33,1.17.65,1.78.94a9.89,9.89,0,0,0,8.44,0c.61-.29,1.2-.61,1.78-.95V51a1,1,0,0,0,1,1H50a8,8,0,0,1,8,8h2A10,10,0,0,0,50,50H38V40.89A23.85,23.85,0,0,0,43,36H54a1,1,0,0,0,1-1V33h3v2h2V29H58ZM46,21.4v.07a49.47,49.47,0,0,1-14.35-4.32,51.57,51.57,0,0,0,10.91-8.3l.32-.32A15.9,15.9,0,0,1,46,18ZM30,2A15.93,15.93,0,0,1,41.59,7l-.45.44A50,50,0,0,1,14,21.33V18A16,16,0,0,1,30,2Zm3.37,39.31a7.88,7.88,0,0,1-6.74,0,22.1,22.1,0,0,1-12.53-18,52,52,0,0,0,15.4-5,51.43,51.43,0,0,0,16.4,5.16A21.75,21.75,0,0,1,45,28H42a1,1,0,0,0-1,1v2H38v2h3v2a.88.88,0,0,0,.06.28A22.07,22.07,0,0,1,33.37,41.31ZM53,34H43V30H53v1H49v2h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    className: "cls-1",
    d: "M26,54H17v2h8.59l1.7,1.71,1.42-1.42-2-2A1,1,0,0,0,26,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    className: "cls-1",
    d: "M33.29,54.29l-2,2,1.42,1.42L34.41,56H43V54H34A1,1,0,0,0,33.29,54.29Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat1);
export default __webpack_public_path__ + "static/media/Treat1.3f785d37886ba51392d853d83742646e.svg";
export { ForwardRef as ReactComponent };